import { createFileRoute } from '@tanstack/react-router';
import { Plug } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PspGuide } from '@/features/integrations/psp-guide';

export const Route = createFileRoute('/m/integrations')({
  component: MerchantIntegrationsPage,
});

function MerchantIntegrationsPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <div className="inline-flex items-center gap-2 rounded-full bg-accent px-3 py-1 text-xs font-medium text-accent-foreground">
          <Plug className="h-3.5 w-3.5" />
          {t('psp_guide.eyebrow')}
        </div>
        <h1 className="text-3xl font-semibold tracking-tight">{t('psp_guide.title')}</h1>
        <p className="max-w-3xl text-muted-foreground">{t('psp_guide.subtitle')}</p>
      </header>
      <PspGuide />
    </div>
  );
}
